import React, { useState } from "react";
import { Helmet } from 'react-helmet-async';

import HeroCTR from "../containers/home/HeroCTR";
import InfoCTR from "../containers/home/InfoCTR";
import IntroCTR from "../containers/home/IntoCTR";
import FindAdventureCTR from "../containers/home/FindAdventureCTR";
import TopTourCTR from "../containers/home/TopTourCTR";
import TopThreeCTR from "../containers/home/TopThreeCTR";
import WhyChooseUsCTR from "../containers/home/WhyChooseUsCTR";
import ReviewCTR from "../containers/home/ReviewCTR";
import AllPackagesCTR from "../containers/home/AllPackagesCTR";
import FAQAccordion from "../components/homefaq/FAQAccordion";
import HelpList from "../components/helplist/HelpList";

const Home = () => {

  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "Do you offer hotel pickup for all tours?",
      answer:
        "Yes — every Bonvoy Tourism tour includes complimentary hotel pickup and drop-off from any hotel, residence, apartment, or villa in Dubai. We also pick up from Dubai Airport and Dubai Cruise Terminal (Port Rashid) at no extra charge. Simply provide your hotel name and room number when booking and your driver will meet you at the lobby at the confirmed time.",
    },
    {
      question: "Are Bonvoy Tourism tours suitable for children?",
      answer:
        "Absolutely. Most of our tours are family-friendly and suitable for children aged 3 and above. Children aged 3–12 qualify for a discounted child rate on most tours. Dune bashing is not recommended for children under 3 years or pregnant women, in line with Dubai Tourism Authority guidelines. Please mention the ages of any children at the time of booking and we will advise on the most suitable experience and pacing.",
    },
    {
      question: "What is your cancellation policy?",
      answer:
        "You can cancel any Bonvoy Tourism booking free of charge up to 24 hours before your tour departure time and receive a full refund. Cancellations made within 8–24 hours of departure are eligible for a 50% refund. Cancellations within 8 hours or no-shows are charged in full. Rescheduling to a different date is available free of charge with 24 hours notice. All cancellation requests must be submitted in writing via email or WhatsApp.",
    },
    {
      question: "Is travel insurance included with every booking?",
      answer:
        "Yes. Every booking with Bonvoy Tourism includes complimentary travel insurance for all tour participants for the duration of their experience. This is automatically included at no extra charge — you do not need to purchase separate insurance for the tour itself. Your peace of mind is covered from the moment your booking is confirmed to the moment you are dropped back at your hotel.",
    },
    {
      question: "How do I contact Bonvoy Tourism?",
      answer:
        "Our team is available 24 hours a day, 7 days a week — including public holidays. You can reach us on +971-55-9215470 via phone or WhatsApp, or by email at contact@bonvoytourism.com. We typically respond to WhatsApp messages within minutes, even late at night before early-morning tours. For new bookings, visit bonvoytourism.com/tours and book directly online with instant confirmation.",
    },
  ];

  const helpItems = [
    {
      heading: "Browse & Choose Your Experience",
      desc: "Visit bonvoytourism.com/tours and choose from 17+ UAE experiences — desert safaris, city tours, dhow cruises, quad biking, day trips to Abu Dhabi, Al Ain, Hatta and more.",
    },
    {
      heading: "Pick Your Date & Group Size",
      desc: "Select your preferred tour date, number of guests (adult/child), and any optional add-ons such as a private car upgrade, Burj Khalifa tickets, or ATV quad bike session.",
    },
    {
      heading: "Pay Securely Online",
      desc: "Complete your booking online using our secure payment system. We accept AED, USD, EUR and CHF. Instant confirmation — your card details are never stored.",
    },
    {
      heading: "Get Instant Confirmation",
      desc: "Receive instant booking confirmation by email with your full tour details, driver WhatsApp number, and hotel pickup instructions. Save it offline just in case.",
    },
    {
      heading: "We Pick You Up — Enjoy the Rest",
      desc: "Your licensed, insured driver arrives at your hotel lobby at the confirmed time. All you have to do is show up. We handle everything from that moment on.",
    },
  ];

  return (
    <div>
      {/* <Helmet>
        <title>Best Tour Company in Dubai | Desert Safari & City Tours – Bonvoy Tourism</title>
        <meta
          name="description"
          content="Bonvoy Tourism — Dubai's top-rated tour operator with 5.0 ★ on TripAdvisor. Book desert safaris, city tours, dhow cruises, quad biking & UAE day trips. Best price guaranteed. Hotel pickup included. Call +971-55-9215470."
        />
        <link rel="canonical" href="https://bonvoytourism.com/" />
      </Helmet> */}
      <Helmet>
        <title>Best Tour Company in Dubai | Desert Safari & City Tours – Bonvoy Tourism</title>
        <meta
          name="description"
          content="Bonvoy Tourism — Dubai's top-rated tour operator with 5.0 ★ on TripAdvisor. Book desert safaris, city tours, dhow cruises, quad biking & UAE day trips. Best price guaranteed. Hotel pickup included. Call +971-55-9215470."
        />
        <link rel="canonical" href="https://bonvoytourism.com/" />
        {/* Open Graph */}
        <meta property="og:title" content="Best Tour Company in Dubai | Desert Safari & City Tours – Bonvoy Tourism" />
        <meta
          property="og:description"
          content="Dubai's top-rated tour operator. Desert safaris, city tours, dhow cruises & UAE day trips. 5★ TripAdvisor. Hotel pickup included."
        />
        <meta property="og:url" content="https://bonvoytourism.com/" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://bonvoytourism.com/images/destination/destination3.webp" />
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Best Tour Company in Dubai | Desert Safari & City Tours – Bonvoy Tourism" />
        <meta
          name="twitter:description"
          content="Dubai's top-rated tour operator. Desert safaris, city tours, dhow cruises & UAE day trips. 5★ TripAdvisor. Hotel pickup included."
        />
        <meta name="twitter:image" content="https://bonvoytourism.com/images/destination/destination3.webp" />
      </Helmet>
      <div className="-mx-6 sm:-mx-10 md:-mx-14 lg:-mx-20">
        <HeroCTR />
      </div>

      <InfoCTR />

      <IntroCTR />

      <div className="-mx-6 sm:-mx-10 md:-mx-14 lg:-mx-20">
        <FindAdventureCTR mt="mt-12" />
      </div>

      <TopTourCTR />

      <div className="-mx-6 sm:-mx-10 md:-mx-14 lg:-mx-20">
        <TopThreeCTR />
      </div>

      <WhyChooseUsCTR />

      <ReviewCTR />

      <div className="-mx-6 sm:-mx-10 md:-mx-14 lg:-mx-20">
        <AllPackagesCTR />
      </div>
      <div className="flex flex-col lg:flex-row lg:gap-12 items-start">
        <div className="flex-1">
          <HelpList
            title="How to Book Your Dubai Tour"
            items={helpItems}
          />
        </div>
        <div className="flex-1">
          <FAQAccordion data={faqs} />
        </div>
      </div>
    </div>
  );
};

export default Home;